module.exports = __webpack_public_path__ + "img/04_sp.c8ae0d5a.jpg";